import type { Collectible, GameState, OutfitStage } from "./types";

const clothesToStage: Array<{ count: number; stage: OutfitStage }> = [
  { count: 5, stage: "royal" },
  { count: 3, stage: "sparkly" },
  { count: 1, stage: "tidy" },
  { count: 0, stage: "ripped" }
];

export function createInitialGameState(): GameState {
  return {
    candy: 0,
    clothes: 0,
    outfitStage: "ripped",
    complete: false,
    collectibles: createCollectibles()
  };
}

export function collectItem(state: GameState, id: string): GameState {
  const item = state.collectibles.find((candidate) => candidate.id === id);

  if (!item || item.collected || state.complete) {
    return state;
  }

  const collectibles = state.collectibles.map((candidate) =>
    candidate.id === id ? { ...candidate, collected: true } : candidate
  );
  const candy = state.candy + (item.kind === "candy" ? 1 : 0);
  const clothes = state.clothes + (item.kind === "clothes" ? 1 : 0);
  const outfitStage = resolveOutfitStage(clothes);
  const complete = candy >= 8 && clothes >= 5;

  return {
    ...state,
    candy,
    clothes,
    outfitStage,
    complete,
    collectibles
  };
}

export function resetGame(): GameState {
  return createInitialGameState();
}

function resolveOutfitStage(clothes: number): OutfitStage {
  return clothesToStage.find((entry) => clothes >= entry.count)?.stage ?? "ripped";
}

function createCollectibles(): Collectible[] {
  return [
    candy("candy-1", "Lolly", 176, 184),
    candy("candy-2", "Cupcake", 368, 142),
    candy("candy-3", "Jellybean", 602, 126),
    candy("candy-4", "Mint", 834, 178),
    candy("candy-5", "Bonbon", 760, 422),
    candy("candy-6", "Cookie", 526, 492),
    candy("candy-7", "Taffy", 292, 456),
    candy("candy-8", "Berry Pop", 130, 382),
    clothes("clothes-1", "Clean Shoes", 252, 268),
    clothes("clothes-2", "Ribbon", 480, 232),
    clothes("clothes-3", "Sparkle Skirt", 686, 286),
    clothes("clothes-4", "Royal Cape", 436, 392),
    clothes("clothes-5", "Crown", 642, 454)
  ];
}

function candy(id: string, label: string, x: number, y: number): Collectible {
  return {
    id,
    kind: "candy",
    label,
    position: { x, y },
    collected: false
  };
}

function clothes(id: string, label: string, x: number, y: number): Collectible {
  return {
    id,
    kind: "clothes",
    label,
    position: { x, y },
    collected: false
  };
}
